import React from 'react'

import {registrationCn} from '../index';

const RegForm = ({children, onSubmit}) => {

  return(
    <form className={registrationCn('Form')} onSubmit={onSubmit}>
      {children}
    </form>
  )
}

export default RegForm;
